import type { TFilterKey as TAnalyticsFilterKey } from '~/types/analytics-context'
import type { TFilterKey as TIapFilterKey } from '~/types/iap-context'

export const getFiltersParamsByNames = (search: string, paramNames: string[]): Record<string, string[]> => {
  const query = new URLSearchParams(search)
  const result: Record<string, string[]> = {}

  for (const paramName of paramNames) {
    result[paramName] = query.get(paramName)?.split(',') || []
  }

  return result
}

type TFilterKey = TAnalyticsFilterKey | TIapFilterKey

type TFilters = Partial<Record<TFilterKey, string[]>>

/** It takes a filters object and returns only tuples whose values are not empty */
export const getFiltersNonEmptyField = (filters: TFilters): TFilters => {
  const newFilters: TFilters = {}

  for (const key in filters) {
    const filterValues = filters[key as TFilterKey]

    if (filterValues && filterValues.length > 0 && filterValues[0]) {
      newFilters[key as TFilterKey] = filterValues
    }
  }

  return newFilters
}
